import { render, staticRenderFns } from "./DeleteTask.vue?vue&type=template&id=466779b4"
import script from "./DeleteTask.vue?vue&type=script&lang=js"
export * from "./DeleteTask.vue?vue&type=script&lang=js"
import style0 from "./DeleteTask.vue?vue&type=style&index=0&id=466779b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports